import { api } from 'app/app.api';

import {
  CreateAccountApiArg,
  CreateAccountApiResponse,
  DeleteAccountApiArg,
  ReadAccountsApiResponse,
  ReadConnectTokenApiResponse,
  ReadTwitterSettingsApiResponse,
  UpdateTwitterApiArg,
} from './types/twitterApi.types';

export const twitterApi = api
  .enhanceEndpoints({
    addTagTypes: ['TwitterAccounts'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      readConnectToken: builder.query<ReadConnectTokenApiResponse, void>({
        query: () => ({
          version: 1,
          path: 'twitter/request_token',
        }),
      }),
      createAccount: builder.mutation<
        CreateAccountApiResponse,
        CreateAccountApiArg
      >({
        query: ({
          auth_token,
          auth_token_secret,
          verifier,
          queueId: queue_id,
        }) => ({
          version: 1,
          path: `twitter/accounts/connect`,
          method: 'POST',
          body: { auth_token, auth_token_secret, verifier, queue_id },
        }),
        invalidatesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
      }),
      updateAccount: builder.mutation<void, UpdateTwitterApiArg>({
        query: ({ account_id, alias_name, queue_id, tweets_enabled }) => ({
          version: 1,
          path: `twitter/accounts/${account_id}`,
          method: 'PATCH',
          body: {
            alias_name,
            queue_id,
            tweets_enabled,
          },
        }),
        invalidatesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
      }),
      deleteAccount: builder.mutation<void, DeleteAccountApiArg>({
        query: ({ accountId }) => ({
          version: 1,
          path: `twitter/accounts/${accountId}`,
          method: 'DELETE',
        }),
        invalidatesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
      }),
      readAccounts: builder.query<ReadAccountsApiResponse, void>({
        query: () => ({
          version: 1,
          path: `twitter/accounts`,
        }),
        providesTags: [{ type: 'TwitterAccounts', id: 'LIST' }],
      }),
      readSettings: builder.query<ReadTwitterSettingsApiResponse, void>({
        query: () => ({
          version: 1,
          path: `twitter/settings`,
        }),
      }),
    }),
  });
